var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { PHASE } from "../routeConfig";
import { savvyLogo, trellisLogo } from "../lib/constants";
import Image from "./Image";
import classNames from "classnames";
import useAppSelector from "../hooks/useAppSelector";
import useMemoryHistory from "../hooks/useMemoryHistory";
function isPhase(value, phases) {
    return phases.includes(value);
}
export function HeaderLogo(_a) {
    var className = _a.className, logo = _a.logo, rest = __rest(_a, ["className", "logo"]);
    return (React.createElement("div", __assign({ "data-cy": "header-logo", className: classNames("mx-auto flex w-full items-center justify-center", className) }, rest),
        React.createElement(Image, { src: logo, alt: "", className: classNames("w-[70px]") })));
}
export default function RouteHeaderLogo(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var _b = useMemoryHistory(), entries = _b.entries, index = _b.index;
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration.isSavvyWidget; });
    var route = entries[index].pathname;
    var trellisLogoRoutes = isSavvyWidget
        ? [
            PHASE.ENTER_CREDENTIALS,
            PHASE.HOME_ENTER_CREDENTIALS,
            PHASE.QUOTE_CONSENT,
        ]
        : [
            PHASE.COMPLETE,
            PHASE.ENTER_CREDENTIALS,
            PHASE.HOME_ENTER_CREDENTIALS,
            PHASE.HAVE_LOGIN,
            PHASE.HOME_HAVE_LOGIN,
            PHASE.REMEMBER_LOGIN,
            PHASE.HOME_REMEMBER_LOGIN,
            PHASE.QUOTE_CONSENT,
        ];
    var isTrellisRoute = Boolean(trellisLogoRoutes.length && isPhase(route, trellisLogoRoutes));
    var isApplicationRoute = isSavvyWidget && !isTrellisRoute;
    var logo = isApplicationRoute ? savvyLogo : trellisLogo;
    return React.createElement(HeaderLogo, __assign({ className: className }, rest, { logo: logo }));
}
